import { Pipe, PipeTransform } from '@angular/core';
import { CountryInfo } from '../interfaces/product';

/// The flag sprite's class for the visitor's country - or, while there is none yet, `flag--none`: the flag's size with
/// nothing drawn. None yet is the server render, which never knows the visitor, and the guess StoreService goes by
/// until Locale/me answers (Pending). Without it the place showed that guess's flag, the United States', or the
/// sprite's blank one, before the visitor's own.
@Pipe({
    name: 'countryFlag'
})
export class CountryFlagPipe implements PipeTransform {
    transform(country: CountryInfo | null | undefined): string {
        const code = country && !country.Pending ? (country.CountryCode || '').toLowerCase() : '';
        return /^[a-z]{2}$/.test(code) ? 'flag-' + code : 'flag--none';
    }
}
